module.exports = __webpack_public_path__ + "img/aviwe-thwalo.591e7638.png";